import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'
import type * as Guide from '../../../shared/domain/guides/types.no-deps'
import type { Embedding } from '../../../shared/domain/embeddings/types.no-deps'

/**
 * Route types
 */
export const route: Route = { method: 'POST', pattern: '/api/embeddings/bulk' }

type Params = never
type Query = never
type Output = never
type Body = { operations: Operation[] }

export type BulkEmbeddingOpsEndpoint = Endpoint<Params, Body, Query, Output>

export const bulkEmbeddingOpsRequest = (request: Request, args: RequestArgs<BulkEmbeddingOpsEndpoint>) =>
    request<BulkEmbeddingOpsEndpoint>(route, args)

/**
 * API types and helper functions
 */
export type OperationType = 'deleteAll' | 'add'

type OperationBase = {
    type: OperationType
}

interface OperationDeleteAllBase extends OperationBase {
    type: 'deleteAll'

    // Setting the version tag will only delete embeddings with the given version
    version?: string
}

export interface OperationDeleteAllFromGuide extends OperationDeleteAllBase {
    guide: Guide.Id
}

export interface OperationDeleteAllFromReport extends OperationDeleteAllBase {
    report: number
}

export type OperationAdd = OperationBase & {
    type: 'add'
    data: Embedding
}

export type OperationDeleteAll = OperationDeleteAllFromGuide | OperationDeleteAllFromReport

export type Operation = OperationDeleteAll | OperationAdd

export function isDeleteAllFromGuideOp(op: OperationDeleteAll): op is OperationDeleteAllFromGuide {
    return op.hasOwnProperty('guide')
}

export function isDeleteAllFromReportOp(op: OperationDeleteAll): op is OperationDeleteAllFromReport {
    return op.hasOwnProperty('report')
}
